// extracted by mini-css-extract-plugin
module.exports = {"billingAddressHeading":"HR","changeBillingAddressLink":"IR","detail":"JR"};